import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse as parseQueryString } from 'qs';
import { withRouter } from 'react-router-dom';
import { withPwaInstallContext } from 'hocs/with-pwa-install';
import { PwaInstallFromMobileModal } from 'components/modals/pwa-install-modal/pwa-install-from-mobile-modal';
import { PwaInstallFromDesktopModal } from 'components/modals/pwa-install-modal/pwa-install-from-desktop-modal';
import { GA } from 'helpers/ga';
import { MODAL_IDS } from 'src/constants';

import './pwa-install-modals.scss';

class PwaInstallModalsUI extends Component {
  static propTypes = {
    location: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  static contextType = withPwaInstallContext;

  state = {
    isFromQr: false,
    isInstallModalFromQrOpened: false,
  };

  componentDidMount() {
    const { location: { search }, history } = this.props;

    const queryParams = parseQueryString(search, { ignoreQueryPrefix: true });
    const isFromQr = queryParams.fromQr;

    if (isFromQr) {
      this.setState({ isFromQr });
      history.replace(queryParams, '');
    }
  }

  componentDidUpdate() {
    const { os, browserName, isDeferredPromptReady } = this.context;
    const { isFromQr, isInstallModalFromQrOpened, isIncognito } = this.state;

    if (!isInstallModalFromQrOpened && isFromQr) {
      if (isDeferredPromptReady || os !== 'android' || browserName !== 'Chrome' || isIncognito) {
        this.openInstallModalFromQr();
      }
    }
  }

  openInstallModalFromQr = () => {
    const { openModal } = this.context;
    openModal(MODAL_IDS.PWA_INSTALL_MOBILE);

    this.setState({ isInstallModalFromQrOpened: true });
  }

  onMobileInstallClick = () => {
    const { onInstallClick } = this.context;

    GA.event({ category: 'App', action: 'click', label: 'App' });

    onInstallClick(MODAL_IDS.PWA_INSTALL_MOBILE);
  }

  onDesktopInstallClick = () => {
    this.context.openModal(MODAL_IDS.PWA_INSTALL);
  };

  render() {
    const {
      isIncognito,
    } = this.context;

    const { isFromQr } = this.state;

    return (
      <>
        {/* MOBILE */}
        <PwaInstallFromMobileModal
          coreProps={{ id: MODAL_IDS.PWA_INSTALL_MOBILE }}
          isFromQr={isFromQr}
          isIncognito={isIncognito}
          onInstallClick={this.onMobileInstallClick}
        />

        {/* DESKTOP */}
        <PwaInstallFromDesktopModal isFromQr={isFromQr} />
      </>
    );
  }
}

export const PwaInstallModals = withRouter(PwaInstallModalsUI);
